<template>
  <div class="card mb-4">
    <div class="card-body">
      <label
        for="customRequirement"
        class="eyebrow-label eyebrow-label--sm mb-2"
      >
        {{ $t("bulk_buy.custom_requirement_label") }}
        <span class="text-danger">*</span>
      </label>
      <div class="row g-3 align-items-stretch">
        <div class="col-lg-8">
          <textarea
            id="customRequirement"
            v-model="text"
            class="form-control h-100"
            rows="2"
            :placeholder="$t('bulk_buy.custom_requirement_placeholder')"
          ></textarea>
        </div>
        <div class="col-lg-4">
          <div class="advisory-note h-100">
            <FontAwesomeIcon
              :icon="['far', 'circle-info']"
              class="flex-shrink-0 mt-1"
            />
            <span class="small">{{
              $t("bulk_buy.custom_requirement_advisory")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const model = defineModel<string | undefined>({ required: true });

const text = computed({
  get: () => model.value ?? "",
  set: (value: string) => {
    model.value = value;
  },
});
</script>
